import React from "react";
import styled from "styled-components";

import { PinContext } from "../../contexts/PinContext";
import { Theme } from "../../utils/theme";
import Text from "../shared/Text";
import CircleIcon from "../shared/CircleIcon";

type pinType = "site";

interface FilterPoint {
  type: pinType;
  color: keyof Theme["colors"];
  text: string;
}

const filterPoints: FilterPoint[] = [
  {
    type: "site",
    color: "darkRed",
    text: "English Heritage Sites",
  },
  // {
  //   type: "event",
  //   color: "darkGreen",
  //   text: "Events"
  // },
  // {
  //   type: "story",
  //   color: "darkBlue",
  //   text: "Your regional sayings",
  // },
];
const Filters: React.FC = (props) => {
  const [pinsMode, setPinsMode] = React.useContext(PinContext);

  const handleFilter = React.useCallback(
    (mode: pinType) => {
      setPinsMode({
        ...pinsMode,
        [mode]: !pinsMode[mode],
      });
    },
    [pinsMode, setPinsMode]
  );

  return (
    <>
      {filterPoints.map((filter, i) => {
        return (
          <Filter
            key={i}
            className={pinsMode[filter.type] ? "active" : "inactive"}
            onClick={() => handleFilter(filter.type)}
          >
            <CircleIcon size={20} icon={filter.type} color={filter.color} />
            <Text>{filter.text}</Text>
          </Filter>
        );
      })}
    </>
  );
};

const Filter = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 1rem;

  &.inactive {
    opacity: 0.5;
  }
  span {
    padding-left: 0.5rem;
  }
`;

export default Filters;
